type Props = {
  size?: number;
  className?: string;
};

export default function IconMessageSequence(props: Props) {
  const { size = 24, className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 5h12A2.5 2.5 0 0 1 21.5 7.5v6" />
      <path d="M5 9h10a2.5 2.5 0 0 1 2.5 2.5v4a2.5 2.5 0 0 1-2.5 2.5h-5l-3.5 3.5V18H5a2.5 2.5 0 0 1-2.5-2.5v-4A2.5 2.5 0 0 1 5 9Z" />
    </svg>
  );
}
